var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header"},[_c('button',{staticClass:"titleBtn btn btn-link",on:{"click":_vm.tapLogo}},[_vm._v("ファイナンシャル・プランニング技能検定３級 学科試験版")]),_c('hr',{staticClass:"m-0"})])
}
var staticRenderFns = []

export { render, staticRenderFns }